export default "__VITE_ASSET__ChUi_C0P__"